export function clearPhoneNumber(str) {
  if (!str) {
    return null;
  }
  return `+${str.replace(/[^\d]/g, '')}`;
}
